import{isShadowRoot as e}from"./instanceOf.js";function o(o,t){var r=t.getRootNode&&t.getRootNode();if(o.contains(t))return!0;if(r&&e(r)){var n=t;do{if(n&&o.isSameNode(n))return!0;n=n.parentNode||n.host}while(n)}return!1}export{o as default};
//# sourceMappingURL=contains.js.map
